export default __webpack_public_path__ + "static/dpworld-24701d365853a1bd230bbe2872395a89.png";